import React from "react";
import TabGuestApplication from "./TabGuestApplication";

type Props = {};

const TabGuestApplicationWrapper = (props: Props) => {
  return (
      <TabGuestApplication />
  );
};

export default TabGuestApplicationWrapper;
